<template>
  <div>
    <v-container fluid grid-list-xl>
      <v-layout row>
        <v-flex xs12 xl12 md12 sm12 lg12 class="mt-2">
          <div class="title text-xs-center form-divider margin-top-40px">
            <v-btn color="indigo darken-2" dark @click="form = !form" large>ثبت داور جدید</v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-form ref="NewSystemUserForm" lazy-validation>
        <v-layout row wrap v-if="form">
          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="User.name"
              :rules="nameRules"
              solo
              placeholder="نام و نام خانوادگی"
              hint="فقط حروف فارسی پشتیبانی میشود"
              append-icon="account_circle"
              clearable
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="User.no"
              :rules="idRules"
              solo
              placeholder="شماره شناسنامه"
              append-icon="account_circle"
              clearable
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-select solo :items="typereffer" placeholder="سمت داور را انتخاب کنید"></v-select>
          </v-flex>
          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="User.codeMelli"
              :rules="nationalCodeRules"
              solo
              placeholder="کد ملی"
              hint="فقط حروف فارسی پشتیبانی میشود"
              append-icon="account_circle"
              mask="##########"
              clearable
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="User.phone"
              solo
              placeholder="تلفن همراه"
              class="ltr"
              mask="phone"
              hint="لطفا شماره تلفن همراه را بدون صفر وارد نمایید"
              append-icon="call"
              clearable
              required
              :rules="userTelRules"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="User.email"
              solo
              placeholder="پست الکترونیکی "
              class="ltr"
              mask
              hint="yourname@example.com"
              append-icon="email"
              clearable
              :rules="userEmailRules"
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="User.username"
              solo
              placeholder="نام کاربری"
              class="ltr"
              append-icon="verified_user"
              clearable
              hint="نام کاربری باید فقط شامل حروف و اعداد انگلیسی باشد"
              required
              :rules="userNameRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="User.password"
              solo
              placeholder="رمز عبور"
              class="ltr"
              append-icon="verified_user"
              clearable
              hint="رمز عبور باید فقط شامل حروف و اعداد انگلیسی باشد"
              required
              :rules="userNameRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-btn
              block
              color="indigo"
              class="bt"
              dark
              :loading="userRegisterLoading"
              @click="create(User)"
            >
              <v-icon>done</v-icon>ثبت
            </v-btn>
            <div class="danger-alert" v-if="error">{{error}}</div>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
  </div>
</template>

<script>
// eslint-disable-next-line
/* eslint-disable */
import RefereeService from "@/services/RefereeServices";

export default {
  data() {
    return {
      error: null,
      enabledUsers: [],
      User: {
        name: null,
        username: null,
        password: null,
      },
      NSUFvalid: false,
      userRegisterLoading: false,
      userDataTableLoading: false,
      userDeletedDataTableLoading: true,
      UserTableDeletedItem: [],
      confirmRecovery: false,
      idRules: [v => !!v || " شماره شناسنامه ضروری است"],
      nationalCodeRules: [
        v => !!v || "کد ملی فیلد ضروری است",
        v => (v && v.length == 10) || "کد ملی باید ده رقمی باشد"
      ],
      numRules: [v => !!v || "این فیلد ضروری است"],
      ncRules: [
        v => !!v || "این فیلد ضروری است",
        v => (v && v.length >= 3) || "حداقل 3 رقم"
      ],
      nameRules: [
        v => !!v || "نام و نام خانوادگی الزامی میباشد",
        v => (v && v.length >= 3) || "حداقل 3 کاراکتر"
      ],
      nameclass: [
        v => !!v || "کلاس مورد نظر را مشخص کنید",
        v => (v && v.length >= 3) || "حداقل 3 کاراکتر"
      ],
      userTelRules: [
        v => !!v || "تلفن همراه الزامی میباشد",
        v => (v && v.length == 10) || "تلفن همراه وارد شده صحیح نمیباشد"
      ],
      userEmailRules: [
        v => !!v || "پست الکترونیکی الزامی میباشد",
        v => /.+@.+/.test(v) || "پست الکترونیکی وارد شده صحیح نمیباشد"
      ],
      userNameRules: [
        v => !!v || "نام کاربری الزامی میباشد",
        v => (v && v.length >= 5) || "نام کاربری باید حد اقل 5 کاراکتر باشد",
        v => /[A-Za-z&0-9]/.test(v) || "نام کاربری وارد شده صحیح نمیباشد"
      ],
      userPermissionRules: [v => !!v || "تعیین دسترسی های کاربر الزامی میباشد"],
      typereffer: ["داور خطا", "داور صحیح", "داور زمان"],
      form: false
    };
  },
  methods: {
    formViewer() {
      this.false = !this.false;
    },
    onFileChanged(event) {
      this.User.image = event.target.files[0];
    },
    async create(user) {
      var mesg = "";
      this.error = null;
      const areAllFieldsFilledIn = Object.keys(this.User).every(
        key => !!this.User[key]
      );
      if (!areAllFieldsFilledIn) {
        this.error = "لطفا تمامی فیلد هارا پر کنید";
        return;
      }
      try {
        res = await RefereeService.post(user);
        // console.log(res);
        if (res == 1) {
          msg = "موفقیت آمیز";
        } else if (res == 0) {
          msg = "ناموفق";
        }
        console.log(msg);
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.danger-alert {
  color: red;
}
.margin-top-40px {
  margin-top: 40px;
}
.bt {
  height: 48px;
  margin: 0;
  width: 100%;
}
</style>
